'use strict';

import SettingsService from '@/api/services/SettingsService';
import NotificationSoundManager from '@/plugins/notificationSoundManager';
import Settings from '@/classes/Settings';
import { SOUNDS } from '@/constants/soundsFile';

const enableNotifications = ({ commit }, enable) => {
  commit('enableNotifications', enable);
};

const setInitialsPreferences = ({ commit }) => {
  return SettingsService.getSettings().then(settingsResponse => {
    const settings = new Settings(settingsResponse);
    commit('updateSettings', settings);
  }, SettingsService.onApiError);
};

const updateSettings = ({ commit, getters }, settingsToUpdate) => {
  const updatedSettings = { ...getters.getSettings, ...settingsToUpdate };
  commit('updateSettings', updatedSettings);
  return SettingsService.setSettings(updatedSettings);
};

const loadCurrentConversation = ({dispatch, rootGetters},) => {
  const conversationNumber = rootGetters['preferences/getSettings'].interfaceState.currentConversation;
  if (conversationNumber) {
    dispatch('conversationsV2/setActiveConversationId', conversationNumber, { root: true });
  }
};

const addContactToFavorites = ({commit, dispatch, getters}, contact) => {
  commit('addContactToFavorites', contact);
  const settings = getters.getSettings;
  return dispatch('updateSettings', settings);
};

const removeContactFromFavorites = ({commit, dispatch, getters}, contact) => {
  commit('removeContactFromFavorites', contact);
  const settings = getters.getSettings;
  return dispatch('updateSettings', settings);
};

/* This section should add Notification Sounds from ASSETS */
/* The following Notification Sounds are from: https://notificationsounds.com */
/* This Notification Sounds will be used as POC until define the deliverable Notification Sounds. */
const requestIncomingNotificationSounds = ({ commit }) => {
  const audioContext = NotificationSoundManager.getAudioContext();

  commit('addIncomingNotificationSound', {
    i18nKey: 'sidePanel.settings.soundOff',
    value: 'off',
    buffer: null
  });

  const soundsCalls = SOUNDS.map( loadSound =>
    fetch(loadSound.asset)
      .then(response => {
        return response.arrayBuffer();
      })
      .then(notificationSound => {
        return audioContext.decodeAudioData(notificationSound, decodedData => {
          commit('addIncomingNotificationSound', {
            label: loadSound.name,
            value: loadSound.name,
            buffer: decodedData
          });
        });
      })
  );

  return Promise.all(soundsCalls);
};

const setIncomingNotificationSound = ({ commit }, notificationSound) => {
  commit('setIncomingNotificationSound', notificationSound);
}

export default {
  enableNotifications,
  requestIncomingNotificationSounds,
  setIncomingNotificationSound,
  updateSettings,
  setInitialsPreferences,
  loadCurrentConversation,
  addContactToFavorites,
  removeContactFromFavorites
};
